/* ABLOOM article.shop: table of contents highlight + mobile sticky product bar. No dependencies. */
(function () {
  var root = document.querySelector('[data-abs]');
  if (!root) return;

  /* Desktop sidebar offset: measure the header and announcement bar that are actually stuck at the top */
  var aside = root.querySelector('.abs-aside');
  if (aside) {
    var bars = document.querySelectorAll('.shopify-section-group-header-group');
    var lastTop = -1, measuring = false;
    var measure = function () {
      measuring = false;
      var bottom = 0;
      bars.forEach(function (el) {
        var pos = getComputedStyle(el).position;
        if (pos !== 'sticky' && pos !== 'fixed') return;
        var r = el.getBoundingClientRect();
        if (r.height > 0 && r.bottom > bottom) bottom = r.bottom;
      });
      var top = Math.round(bottom) + 24;
      if (top !== lastTop) { lastTop = top; aside.style.setProperty('--abs-top', top + 'px'); }
    };
    var queue = function () { if (!measuring) { measuring = true; requestAnimationFrame(measure); } };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    window.addEventListener('load', queue);
    measure();
    /* The header can hide/show with a transition; measure again once it has settled */
    window.addEventListener('scroll', function () { clearTimeout(aside._absT); aside._absT = setTimeout(queue, 260); }, { passive: true });
  }

  if (!('IntersectionObserver' in window)) return;

  /* Keep the active item visible inside a scrollable table of contents (without scrolling the page) */
  function reveal(link) {
    var list = link.closest('ol');
    if (!list || list.offsetParent === null || list.scrollHeight <= list.clientHeight) return;
    var o = list.getBoundingClientRect(), r = link.getBoundingClientRect();
    if (r.top < o.top) list.scrollTop += r.top - o.top - 8;
    else if (r.bottom > o.bottom) list.scrollTop += r.bottom - o.bottom + 8;
  }

  /* Highlight the current section in the table of contents */
  var links = root.querySelectorAll('[data-abs-toc] a');
  if (links.length) {
    var byId = {};
    links.forEach(function (l) { var id = decodeURIComponent(l.hash.slice(1)); (byId[id] = byId[id] || []).push(l); });
    /* Current section = last heading above 25% of the viewport (also correct after jumps, e.g. clicking a ToC link) */
    var heads = Object.keys(byId).map(function (id) { return document.getElementById(id); }).filter(Boolean);
    var currentId = null, spying = false;
    var spy = function () {
      spying = false;
      var line = window.innerHeight * 0.25, id = null;
      for (var i = 0; i < heads.length; i++) { if (heads[i].getBoundingClientRect().top <= line) id = heads[i].id; else break; }
      if (id === currentId) return;
      currentId = id;
      links.forEach(function (l) { l.removeAttribute('aria-current'); });
      if (id) (byId[id] || []).forEach(function (l) { l.setAttribute('aria-current', 'true'); reveal(l); });
    };
    window.addEventListener('scroll', function () { if (!spying) { spying = true; requestAnimationFrame(spy); } }, { passive: true });
    spy();
    var mobileToc = root.querySelector('.abs-toc--mobile');
    if (mobileToc) mobileToc.addEventListener('click', function (e) { if (e.target.closest('a')) mobileToc.open = false; });
  }

  /* Sticky product bar: shows after the reader passes the second H2, hides near product blocks, CTA and related articles */
  var bar = root.querySelector('[data-abs-sticky]');
  var start = root.querySelector('[data-abs-sticky-start]');
  if (!bar || !start) return;
  try { if (sessionStorage.getItem('abs-sticky-closed')) { bar.remove(); return; } } catch (e) {}
  bar.hidden = false;
  var past = false, blockers = new Set();
  function update() {
    var on = past && blockers.size === 0;
    bar.classList.toggle('is-visible', on);
    document.documentElement.classList.toggle('abs-sticky-on', on);
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var now = start.getBoundingClientRect().top < 0;
      if (now !== past) { past = now; update(); }
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  var stopper = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) blockers.add(e.target); else blockers.delete(e.target); });
    update();
  });
  root.querySelectorAll('[data-abs-sticky-stop]').forEach(function (el) { stopper.observe(el); });
  var footer = document.querySelector('.shopify-section--footer, footer');
  if (footer) stopper.observe(footer);
  bar.querySelector('[data-abs-close]').addEventListener('click', function () {
    bar.remove();
    document.documentElement.classList.remove('abs-sticky-on');
    try { sessionStorage.setItem('abs-sticky-closed', '1'); } catch (e) {}
  });
})();
